import settingsLinks from './settingsLinks';

export default settingsLinks;
